<template>
    <div class="card">
        <div class="card-header">
            <h4 class="card-title">
                {{$t("consumoPorHoras")}}
            </h4>
            <p class="card-category">
                {{$t("graficaDeConsumoAgrupadaPorTramosHorarios")}}
            </p>
        </div>
        <div class="card-body">
            <div class="row">
                <div class="col-md-12">
                    <canvas id="chart"></canvas>
                </div>
            </div>
        </div>
        <div class="card-footer">
            <hr>
            <div class="stats">
                <i class="fa fa-clock"></i> {{lastDate | timeago}}
            </div>
        </div>
    </div>
</template>
<script>

    import swal from 'sweetalert2'
    import Ticket from '../../../Widgets/Ticket.vue'

    export default {
        created() {
            this.getConsumoHoras();
        },
        props: ['onlineDetails', 'lastDate', 'idBusiness'],
        data() {
            return {}
        },
        components: {
            Ticket,
        },
        methods: {
            getConsumoHoras() {

                var tpvs = [];
                this.onlineDetails.forEach(function (x) {
                    if (x && x.online == 1) {
                        tpvs.push(x.idTpv);
                    }
                });


                var config = {
                    params: {
                        idBusiness: this.idBusiness,
                        listTpv: JSON.stringify(tpvs),
                        jwt: this.$store.getters.jwt
                    },
                    headers: {'Authorization': "Bearer " + this.$store.getters.jwt}
                };

                let vm = this;
                this.axios.get(this.$store.getters.apiUrl + "online/getConsumoHoras", config)
                    .then(function (response) {
                        if (response.data.response) {
                            vm.initChart(response.data.result.listHours);
                        } else {
                            swal({
                                title: vm.$t('atencion'),
                                text: response.data.message,
                                confirmButtonClass: 'btn btn-info btn-fill',
                                type: 'error'
                            });
                        }
                    })
                    .catch(function (error) {
                        console.log(error);
                    });
            },
            initChart(listHours) {

                var labels = listHours.map(function (x) {
                    return x.hour;
                });


                var data = listHours.map(function (x) {
                    return x.amount;
                });

                if(this.$chart){
                    this.$chart.destroy();
                }

                this.$chart = new Chart('chart', {
                    type: 'line',
                    data: {
                        labels: labels,
                        datasets: [{
                            data: data,
                            backgroundColor: "rgba(192,214,8,0.3)",
                            pointBackgroundColor: "rgba(0,0,0,1)",
                            borderColor: "rgba(0,0,0,0.6)",
                            borderWidth: 1
                        }]
                    },
                    options: {
                        maintainAspectRatio: false,
                        legend: {
                            display: false,
                        },
                        
                        scales: {
                             xAxes: [    
                                {
                                    ticks: {
                                        alignToPixels:true, 
                                        stepSize: 1, //este atributo sirve para la escala del numero que queremos representar
                                    },
                                    scaleLabel: {
                                        display: true,
                                        labelString: 'Horas del día'
                                    }
                                }
                            
                            ],

                            yAxes: [    
                                {
                                    ticks: {
                                      beginAtZero: true, 
                                      min:0,
                                      alignToPixels:true, 
                                      stepSize: 100,
                                    },
                                    scaleLabel: {
                                        display: true,
                                        labelString: 'Euros'
                                    }
                                }
                            
                            ]
                            
                            
                        }
                    }
                });


            }

        },
        watch: {
            onlineDetails: function (newOnlineDetails, oldOnlineDetails) {
                this.getConsumoHoras();
            }
        },


    }
</script>
<style scoped>
    .card-body {
        padding: 10px 15px;
    }

    .title {
        font-weight: bold;
    }

    tfoot tr td {
        font-size: 1.2em;
        color: #fff;
        text-shadow: 1px 1px #111;
        font-weight: bold;
    }

    .card-category {
        color: #9a9a9a
    }


</style>



// WEBPACK FOOTER //
// src/pages/Dashboard/Online/Widgets/ConsumoHoras.vue